import AOS from 'aos'
import 'aos/dist/aos.css'
import React from 'react'

const Blogs = () => {
    AOS.init()
    return (
        <div id="blogs" className="my-20">
            <div data-aos="fade-down" data-aos-duration="3000" className="flex flex-col items-center mt-20">
                <h2 class="text-4xl text-warning font-bold">My Blogs</h2>
                <p>Coming soon...</p>
            </div>
        </div>
    )
}

export default Blogs
